import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {Button} from '@udemy/react-core-components';

import styles from '../pop-quiz-modal.module.less';
import {mapLectureTypeToIconGlyph} from './map-related-lectures';
import {PopQuizRelatedLecture} from './types';

interface PopQuizLectureLinkProps {
    lecture: PopQuizRelatedLecture;
    onSelect: () => void;
}

export function PopQuizLectureLink({lecture, onSelect}: PopQuizLectureLinkProps) {
    const {gettext, interpolate} = useI18n();

    return (
        <Button
            componentClass="a"
            udStyle="ghost"
            href={lecture.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles['lecture-link']}
            onClick={onSelect}
        >
            <div className={styles['lecture-link-start']}>
                <Icon
                    glyph={mapLectureTypeToIconGlyph(lecture.type)}
                    label={false}
                    size="small"
                    color="inherit"
                />
                <div className={styles['lecture-link-text']}>
                    {interpolate(
                        gettext('View related lecture: %(lectureTitle)s'),
                        {lectureTitle: lecture.title},
                        true,
                    )}
                </div>
            </div>
            <Icon glyph="open-in-new" label={false} size="small" color="inherit" />
            <span className="ud-sr-only">{gettext('Opens in a new tab')}</span>
        </Button>
    );
}
